export const DROPZONE_LABELS = {
    dropzoneText: 'Ajouter une image',
    getFileLimitExceedMessage: (filesLimit) => `La limite a été dépassée. Seulement ${filesLimit} fichiers sont autorisés`,
    getFileAddedMessage: (fileName) => `Le fichier ${fileName} a été ajouté.`,
    getFileRemovedMessage: (fileName) => `Le fichier ${fileName} a été enlevé.`,
    getDropRejectMessage: (rejectedFile, acceptedFiles, maxFileSize) => {
        if (rejectedFile.size > maxFileSize) {
            return `L'image ${rejectedFile.name} est supérieure à ${maxFileSize / 1000000} Mo.`;
        }
        return `Le fichier ${rejectedFile.name} n'est pas une image.`;
    },
    getErrorMessage: (filename) => `Une erreur est survenue${filename ? ` sur le fichier ${filename}` : ''}`,
};
